module.exports = __webpack_public_path__ + "media/images/landing/cyber/network-interruption-f611bba413da8ecd2e868681379c2359.png";